/**
 * Data layer for `pixel-capi-dual-send-with-dedup-via-event-id`. Thin typed fetch wrappers over /api/v1/pixel-capi-dual-send-with-dedup-via-event-id.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface PixelCapiDualSendWithDedupViaEventIdRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListPixelCapiDualSendWithDedupViaEventIdResponse {
	count: number;
	items: PixelCapiDualSendWithDedupViaEventIdRow[];
}

export interface CreatePixelCapiDualSendWithDedupViaEventIdBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/pixel-capi-dual-send-with-dedup-via-event-id";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListPixelCapiDualSendWithDedupViaEventIdResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListPixelCapiDualSendWithDedupViaEventIdResponse>(res);
}

export async function create(body: CreatePixelCapiDualSendWithDedupViaEventIdBody): Promise<PixelCapiDualSendWithDedupViaEventIdRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<PixelCapiDualSendWithDedupViaEventIdRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const pixelCapiDualSendWithDedupViaEventIdQueryKeys = {
	all: ["pixel-capi-dual-send-with-dedup-via-event-id"] as const,
	list: () => [...pixelCapiDualSendWithDedupViaEventIdQueryKeys.all] as const,
	detail: (id: string) => [...pixelCapiDualSendWithDedupViaEventIdQueryKeys.all, id] as const,
};
